import { BaseService } from '../../infra/base.service'
import type { CustomerCard } from './customer-card.entity'
import type { CustomerCardsRepository } from './customer-cards.repository'

export class CustomerCardsService extends BaseService<CustomerCard> {
    constructor(private rep: CustomerCardsRepository) {
        super(rep)
    }
}
